import { useState, useEffect, useRef } from 'react';

export default function Positioning() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const strengths = [
    {
      icon: 'ri-team-line',
      title: 'Đội ngũ kỹ sư và tư vấn kinh nghiệm thực chiến'
    },
    {
      icon: 'ri-brain-line',
      title: 'Am hiểu nghiệp vụ doanh nghiệp, không chỉ lập trình'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Quy trình làm việc rõ ràng, minh bạch'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Cam kết chất lượng, bảo mật và đồng hành dài hạn'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24" style={{ backgroundColor: '#f6f7f8' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2a4b7c] mb-6">
            NĂNG LỰC & UY TÍN
          </h2>
          <div className={`w-20 h-1 bg-[#00c897] mx-auto transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`} style={{ transformOrigin: 'center' }}></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className={`flex items-start gap-6 p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 hover:border-[#06b6d4] transition-all duration-500 hover:shadow-xl ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${400 + index * 100}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#06b6d4] to-[#00c897] rounded-xl flex-shrink-0">
                <i className={`${strength.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#2a4b7c] leading-tight pt-2">
                {strength.title}
              </h3>
            </div>
          ))}
        </div>

        <div className={`max-w-4xl mx-auto text-center transition-all duration-1000 delay-800 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}>
          <div className="bg-gradient-to-br from-[#2a4b7c] to-[#1e3a5f] p-12 rounded-3xl relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#06b6d4] rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#00c897] rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center bg-[#00c897]/20 rounded-2xl mx-auto mb-6">
                <i className="ri-hand-heart-line text-3xl text-[#00c897]"></i>
              </div>
              
              <p className="text-2xl lg:text-3xl font-bold text-white leading-relaxed">
                StackWay định vị mình là <span className="text-[#00c897]">đối tác công nghệ</span>,<br />
                không phải đơn vị gia công ngắn hạn
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}